import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Starter } from '../../types/baking';
import { StarterList } from './StarterList';
import { NewStarterModal } from './NewStarterModal';
import { ActiveStarter } from '../home/ActiveStarter';
import { addStarter } from '../../lib/store';

interface StarterPageProps {
  starters: Starter[];
  onUpdateStarter: (id: string, updates: Partial<Starter>) => void;
}

export function StarterPage({ starters, onUpdateStarter }: StarterPageProps) {
  const [showNewStarter, setShowNewStarter] = useState(false);

  const handleNewStarter = async (starterData: Omit<Starter, 'id' | 'createdAt'>) => {
    try {
      await addStarter(starterData);
      setShowNewStarter(false);
    } catch (error) {
      console.error('Error creating starter:', error);
    }
  };

  // Find the favorite starter
  const favoriteStarter = starters.find(starter => starter.isFavorite);

  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="mb-6 mt-4">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl text-white font-brand font-light italic">My Starters</h1>
          <button
          onClick={() => setShowNewStarter(true)}
          className="self-end flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-amber-500/90 to-amber-600/90 hover:from-amber-400 hover:to-amber-600 text-white rounded-xl disabled:opacity-50 transition-all duration-300"
        >
          NEW STARTER
          </button>
        </div>
        <p className="text-sm text-white mt-1">
            Manage and track your starters, feed them or create a new one.
        </p>
      </div>

      <StarterList
        starters={starters}
        onUpdateStarter={onUpdateStarter}
        onCreateStarter={() => setShowNewStarter(true)}
      />

      <NewStarterModal
        isOpen={showNewStarter}
        onClose={() => setShowNewStarter(false)}
        onSubmit={handleNewStarter}
      />
    </div>
  );
}